import React from 'react';
import { IconProps } from '../../types/types';

const ViewIcon: React.FC<IconProps> = ({ size = '19', color = '#292D32' }) => (
  <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.1849 9.5C12.1849 10.985 10.9849 12.185 9.49994 12.185C8.01494 12.185 6.81494 10.985 6.81494 9.5C6.81494 8.015 8.01494 6.815 9.49994 6.815C10.9849 6.815 12.1849 8.015 12.1849 9.5Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M9.5 15.7025C12.1475 15.7025 14.615 14.1425 16.3325 11.4425C17.0075 10.385 17.0075 8.60751 16.3325 7.55001C14.615 4.85001 12.1475 3.29001 9.5 3.29001C6.8525 3.29001 4.385 4.85001 2.6675 7.55001C1.9925 8.60751 1.9925 10.385 2.6675 11.4425C4.385 14.1425 6.8525 15.7025 9.5 15.7025Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  
);

export default ViewIcon;